import Cookies from "js-cookie";

  export const hasUniqueID = () => {
    if(Cookies.get('uniqueId')) {
        return true;
    } else {
        return window.location.href = '/'
    }
}



